module.exports = __webpack_public_path__ + "static/img/bg-number.b4c0493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-number.png
// module id = BfKe
// module chunks = 1